/* eslint-disable */
// @ts-nocheck
import PromisePolyfill from "promise-polyfill";

// True for any legacy browser that requires the shim in ./ie11 — detected
// entirely by feature detection so it covers IE 8/9/11 as well as other old
// engines in the browserslist (Android 4.4 stock, Samsung Internet 4, UC Browser 12).
// We check for ES2015 fundamentals (Symbol, Map, Set) plus the IE-exclusive
// documentMode property so that every known unsupported engine is caught.
export const isLegacyBrowser =
  typeof window !== "undefined" &&
  typeof document !== "undefined" &&
  (typeof Symbol === "undefined" ||
    typeof Map === "undefined" ||
    typeof Set === "undefined" ||
    !!(document as any).documentMode); // IE 8–11 exclusive

// Eventually, we should include all our vendor code here.
// For now, it essentially functions as a polyfill file.

// loading-attribute-polyfill is located in bootstrapper.ts instead
// since it needs to run after rehydration.

// All polyfills are applied via FEATURE DETECTION. The isIE11 flag above uses
// the same approach: it fires for any browser missing ES2015 fundamentals,
// not just IE11. Heavy polyfills are loaded through dynamic imports so modern
// browsers pay no download/parse cost.

export const loadPolyfills = async () => {
  if (typeof window === "undefined") {
    return Promise.resolve();
  }

  const w = window as any;

  // Promise must exist before any dynamic import() path executes.
  if (!w.Promise) {
    w.Promise = PromisePolyfill;
  }

  const polyfillLoads: Array<Promise<any>> = [];

  // core-js (full ES2015-2017 suite): load only when an essential built-in is
  // missing. Covers older non-IE11 engines (e.g., Android 4.4 stock browser and
  // Samsung Internet 4); IE11 is handled by the dedicated IE11 polyfill path.
  const needsCoreJs =
    (w.Promise &&
      w.Promise.prototype &&
      typeof w.Promise.prototype.finally !== "function") ||
    typeof w.Symbol === "undefined" ||
    typeof Object.assign !== "function" ||
    typeof (Object as any).values !== "function" ||
    typeof (Array as any).from !== "function" ||
    typeof (Array.prototype as any).includes !== "function" ||
    typeof (String.prototype as any).includes !== "function" ||
    typeof (String.prototype as any).padStart !== "function";

  if (needsCoreJs && !(document as any).documentMode) {
    polyfillLoads.push(
      import(
        /* webpackChunkName: "polyfills/core-js" */
        "core-js"
      ).then(
        () =>
          import(
            /* webpackChunkName: "polyfills/core-js" */
            "core-js/es/promise"
          )
      )
    );
  }

  if (!w.fetch) {
    polyfillLoads.push(
      import(
        /* webpackChunkName: "polyfills/fetch" */
        "whatwg-fetch"
      )
    );
  }

  if (
    !isLegacyBrowser &&
    (!Element.prototype.matches || !Element.prototype.closest)
  ) {
    // isLegacyBrowser is already true for browsers lacking matches/closest, so they
    // are handled by the legacy shim below; this path is for the narrow case
    // of a browser that has Symbol/Map/Set but still lacks closest.
    polyfillLoads.push(
      import(
        /* webpackChunkName: "polyfills/element-closest" */
        "element-closest"
      )
    );
  }

  // Standard IntersectionObserver detection (also treats missing `isIntersecting`
  // partial support as unsupported), so genuinely-capable modern browsers are skipped.
  const intersectionObserverUnsupported =
    typeof w.IntersectionObserver === "undefined" ||
    typeof w.IntersectionObserverEntry === "undefined" ||
    !w.IntersectionObserverEntry ||
    !w.IntersectionObserverEntry.prototype ||
    !("isIntersecting" in w.IntersectionObserverEntry.prototype);

  if (intersectionObserverUnsupported) {
    polyfillLoads.push(
      import(
        /* webpackChunkName: "polyfills/intersection-observer" */
        "intersection-observer"
      )
    );
  }

  if (isLegacyBrowser) {
    polyfillLoads.push(
      import(
        /* webpackChunkName: "polyfills/ie11-shim" */
        "./ie11"
      ).then(({ load }) => load())
    );
  }

  await Promise.all(polyfillLoads);

  // getAttributeNames is already patched inline in ./ie11 for legacy browsers.
  // This covers the rare modern browser that still lacks it.
  if (Element.prototype.getAttributeNames == undefined) {
    Element.prototype.getAttributeNames = function () {
      var attributes = this.attributes;
      var length = attributes.length;
      var result = new Array(length);
      for (var i = 0; i < length; i++) {
        result[i] = attributes[i].name;
      }
      return result;
    };
  }

  return;
};
